// Base stylesheet needed for every page
import './scss/app.scss';
import 'bootstrap/dist/js/bootstrap.bundle.js';

import './scripts/navigation';
import './scripts/content-switcher';
import { initSwipers } from './scripts/swiper-init';
import './scripts/auto-suggest';
import './scripts/header';

document.addEventListener('DOMContentLoaded', () => {
    initSwipers();
});
